import { styled, Typography } from '@creditas-ui/react';

const Tag = styled(Typography)`
  opacity: 0.6;
`;

const Title = styled(Typography)`
  margin-bottom: 8px;
  white-space: pre-wrap;
`;

const Description = styled(Typography)`
  white-space: pre-wrap;
  max-width: 348px;
`;

const QrCode = styled.div`
  background: white;
  border: solid 8px white;
  border-radius: 6px;

  & > img {
    width: 120px;
  }
`;

export { Tag, Title, Description, QrCode };
